module.exports = __webpack_public_path__ + "static/media/ball-icon.5d5f4c98.svg";